import React, { Component } from "react";
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { Tab } from "bootstrap";

//var connection = new HubConnection('/paymenthub');

//connection.on('RefreshGrid', data => {
//    console.log(data);
//});

//connection.start().then((e) => {
//    console.log('Conectado');
//}).catch((e) => {
//    console.log(e)
//});

//var connection = new signalR.HubConnectionBuilder().whithUrl("/paymenthub").build()
//connection.on("RefreshGrid", (obj) => {

//    console.log(obj);
//})
//connection.start().then(() => {
//    console.log('Conectado');
//})

export class HistoryPaymentOnline extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loadingPage: false, history: []
        }
    }

    componentDidMount() {
        this.getProcess();
        var it = setInterval(() => {
            this.getProcess();
        }, 3000);

        this.setConnection();
    }

    async setConnection() {
        try {
            const connection = new HubConnectionBuilder().withUrl("/paymenthub").configureLogging(LogLevel.Information).build();

            connection.on('RefreshGrid', data => {
                this.getProcess();
                console.log(data);
            });

            await connection.start().then((e) => {
                console.log('Conectado');
            }).catch((e) => {
                console.log(e)
            });

            connection.invoke("SendPayment").catch((e) => { console.log(e) })
        } catch (e) {

        }
    }


    formatCurrency(val) {

        var formatted = new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 2
        }).format(val);
        return <label className={formatted.indexOf('-') != -1 ? 'en-rojo' : 'saldo-ok'}> {formatted}</ label>;
    }

    async getProcess() {
        this.setState({ loadingPage: true });
        const request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            },
        }

        const response = await fetch(`HistoryPayment/GetHistoryPaymentByProcessId?processId=${parseInt(window.location.href.substring(window.location.href.lastIndexOf('/') + 1))}`, request);
        const data = await response.json();
        this.setState({ loadingPage: false });

        if (response.redirected) {
            window.location.href = response.url;
        }

        if (data) {
            this.setState({ history: data });
        }
    }

    render() {
        return (
            <div>
                {this.state.history.length > 0 ? <h2 className="text-center display-3">{this.state.history[0].processName}</h2> : <h2></h2>}
                <table className="float-right">
                    <tr>
                        <h4 className="text-right">Total enrolados</h4>
                    </tr>
                    <tr>
                        <h3 className="text-center display-4">{this.state.history.length}</h3>
                    </tr>
                </table>



                <table className="table table-striped">
                    <th scope="col">
                        <b>Nombre enrolado</b>
                    </th>
                    <th scope="col">
                        <b>Nombre enrolador</b>
                    </th>
                    <th scope="col">
                        <b>Pago</b>
                    </th>
                    {
                        this.state.history.map((item) =>
                            <tr>
                                <td>
                                    {item.name}
                                </td>
                                <td>
                                    {item.enrollament}
                                </td>
                                <td>
                                    {this.formatCurrency(item.pay)}
                                </td>
                            </tr>

                            //<div className="row">
                            //    <div className="col-lg-4 border">{item.name}</div>
                            //    <div className="col-lg-4 border">{item.enrollament}</div>
                            //    <div className="col-lg-4 border">{this.formatCurrency(item.pay)}</div>
                            //</div>
                        )
                    }
                </table>
            </div>
        )
    }
}